// Icelandic
export const is = {
    weeklyRewards: 'Vikuleg verðlaun eftir',
    days: 'daga',
    hours: 'klst',
    minutes: 'mín',
    seconds: 'sek',
    authenticating: 'Auðkenning',
    verifyWallet: 'Vinsamlegast bíddu á meðan við staðfestum veskið þitt',
    authRequired: 'Auðkenningar krafist',
    authFailed: 'Auðkenning mistókst. Vinsamlegast reyndu aftur.',
    points: 'Stig',
    rank: 'Staða',
    of: 'af',
    players: 'leikmenn',
    weeklyTopPlayers: 'Efstu leikmenn vikunnar',
    thisWeekLeaderboard: 'Stigatafla vikunnar',
    rankingsReset: 'Stigatafla endurstillist á miðnætti UTC á sunnudögum',
    yourPoints: 'Þín stig',
    dailyRewardAvailable: 'Dagleg verðlaun í boði!',
    nextClaimAvailable: 'Næsta krafa möguleg eftir:',
    claimDailyReward: 'Krefjast daglegra verðlauna',
    claiming: 'Krefst...',
    multiplier: 'Margfaldari',
    bonusPointsMultiplier: 'Bónusstigamargfaldari',
    outOf: 'af',
    loading: 'Hleður...',
    errorLoading: 'Villa við hleðslu',
    noEntries: 'Engar færslur enn',
    leaderboard: 'Stigatafla',
    tasks: 'Verkefni',
    rules: 'Reglur',
    profile: 'Prófíll',
    comingSoon: 'Væntanlegt...',
    completedTasks: 'Lokið verkefnum',
    dailyRewardsClaimed: 'Dagleg verðlaun móttekin',
    times: 'sinnum',
    recentActivity: 'Nýleg virkni',
    noRewardsClaimed: 'Engin verðlaun móttekin enn',
    dailyReward: 'Dagleg verðlaun',
    howItWorks: 'Hvernig þetta virkar',
    welcomeMessage:
        'Velkomin í Coinomi Rewards! Safnaðu stigum með því að klára ýmis verkefni og klifraðu upp stigatöfluna.',
    dailyRewardsTitle: 'Dagleg verðlaun',
    dailyRewardsRules: [
        'Krafstu daglegra verðlauna á 24 tíma fresti',
        'Hver krafa gefur þér 100 stig',
        'Stig margfaldast eftir margfaldara þínum',
    ],
    multiplierBonusesTitle: 'Margfaldarabónusar',
    multiplierBonusesRules: [
        'Byrjaðu með 1x margfaldara',
        'Tengdu Telegram fyrir +10% bónus',
        'Staðfestu tölvupóst fyrir +10% bónus',
        'Bónusar safnast upp fyrir hámarksverðlaun',
    ],
    leaderboardTitle: 'Stigatafla',
    leaderboardRules: [
        'Kepptu við aðra leikmenn',
        'Staða uppfærist í rauntíma',
        'Efstu leikmenn fá sérstök verðlaun',
    ],
    boostEarningsTitle: 'Auktu ávinning þinn',
    boostEarningsRules: [
        'Kláraðu áskoranir fyrir bónusa',
        'Vertu með í Telegram samfélaginu okkar',
        'Vertu virkur til að hámarka verðlaun þín',
    ],
    challenges: 'Áskoranir',
    telegramChallenge: 'Telegram áskorun',
    emailChallenge: 'Tölvupóstsáskorun',
    connectTelegram: 'Tengja við Telegram',
    shareEmail: 'Deila tölvupósti',
    telegramSuccess: '🎉 Til hamingju! Þú færð nú 10% varanlegan bónus á öll verðlaun!',
    telegramPrompt:
        'Tengdu Telegram reikninginn þinn til að fá 10% varanlegan bónus á öll verðlaun!',
    emailSuccess: '🎉 Til hamingju! Þú færð nú 10% varanlegan bónus á öll verðlaun!',
    emailPrompt: 'Deildu tölvupóstinum þínum til að fá 10% varanlegan bónus á öll verðlaun!',
    connectEmail: 'Tengja tölvupóst',
    cancel: 'Hætta við',
    emailPrivacy:
        'Við notum tölvupóstinn þinn aðeins fyrir mikilvægar uppfærslur og tilkynningar um verðlaun.',
    connectYourEmail: 'Tengdu tölvupóstinn þinn',
    emailBonus: '🎉 Fáðu 10% varanlegan bónus á öll verðlaun með því að tengja tölvupóstinn þinn!',
    enterValidEmail: 'Vinsamlegast sláðu inn gilt netfang',
    emailAddress: 'Netfang',
    errorSavingEmail: 'Villa við að vista tölvupóst. Vinsamlegast reyndu aftur.',
    claimButton: 'Krefjast',
    earnedReward: 'Áunnin verðlaun',
    rewardValue: '{{amount}} Stig',
    claimingReward: 'Krefst...',
    claimSuccess: 'Tókst að krefjast {{amount}} stiga!',
    claimError: 'Mistókst að krefjast verðlauna. Vinsamlegast reyndu aftur.',
    privacyDisclaimer:
        'Coinomi safnar ekki persónuupplýsingum; þriðja aðila kerfi sér um örugga stjórnun stiga og félagslegra tenginga.',
    streakBonus: 'Raðbónus',
    streakDays: '{{days}}/5 Dagar',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Auka',
    streakDescription: 'Krefstu verðlauna 5 daga í röð fyrir hámarksbónus',
    streakToday: 'Í dag',
    streakMissed: 'Misst af',
    streakComplete: 'Lokið',
    streakActive: 'Virk röð',
    streakLost: 'Röð töpuð',
    streakNext: 'Næst',
    home: 'Heim',
    currentStreak: 'Núverandi röð',
    totalClaims: 'Heildarfjöldi krafna',
    userStats: 'Þínar tölfræðiupplýsingar',
    referrals: 'Tilvísanir',
    referralProgram: 'Tilvísunarkerfi',
    howReferralWorks: 'Hvernig tilvísanir virka:',
    referralSteps: [
        'Deildu tilvísunarhlekknum þínum með vinum',
        'Þegar þeir skrá sig með hlekknum þínum verða þeir tilvísanir þínar',
        'Fáðu bónusstig fyrir hverja virka tilvísun',
        'Fylgstu með tilvísunum þínum og ávinningi hér',
    ],
    referralRewards: 'Tilvísunarstig eru veitt:',
    referralBonuses: [
        '100 stig þegar þú vísar einhverjum',
        '10% af öllum stigum sem tilvísunin fær',
    ],
    yourReferralLink: 'Tilvísunarhlekkurinn þinn',
    copyToClipboard: 'Afrita á klemmuspjald',
    linkCopied: 'Hlekkur afritaður á klemmuspjald!',
    totalReferrals: 'Heildarfjöldi tilvísana',
    yourReferralCode: 'Tilvísunarkóðinn þinn',
    referralCodeCopied: 'Tilvísunarkóði afritaður!',
    editReferralCode: 'Breyta tilvísunarkóða',
    editReferralCodeInstructions:
        'Veldu nýjan tilvísunarkóða. Hann verður að vera að minnsta kosti 5 stafir og getur innihaldið bókstafi og tölur.',
    newReferralCode: 'Nýr tilvísunarkóði',
    referralCodeRequirements: 'Lágmark 5 stafir, aðeins bókstafir og tölur',
    updating: 'Uppfærir...',
    update: 'Uppfæra',
    referralCodeTaken: 'Þessi tilvísunarkóði er þegar í notkun',
    haveReferralCode: 'Ertu með tilvísunarkóða?',
    enterReferralCodePrompt:
        'Ef einhver vísaði þér, sláðu inn kóðann þeirra hér til að tengja reikningana.',
    enterReferralCode: 'Sláðu inn tilvísunarkóða',
    enterReferralCodeInstructions: 'Sláðu inn tilvísunarkóðann sem var deilt með þér.',
    referralCode: 'Tilvísunarkóði',
    referralCodeFormat: 'Aðeins bókstafir og tölur',
    submitting: 'Sendir...',
    submit: 'Senda',
    enterCode: 'Slá inn kóða',
    pleaseAddtoken: 'Vinsamlegast bættu token breytu við vefslóðina',
    authenticationError: 'Villa kom upp við auðkenningu',
    noUserFound: 'Enginn notandi fannst',
    userNotFoundMessage: 'Gat ekki fundið notandagögn',
    backToHome: 'Til baka á forsíðu',
    retry: 'Reyna aftur',
    baseMultiplier: 'Grunnmargfaldari',
    telegramBonus: 'Telegram bónus',
    referralChallenge: 'Tilvísunaráskorun',
    referralChallengePrompt:
        'Bjóddu vinum og fáðu bónusstig! Fáðu 100 stig fyrir hverja tilvísun plús 10% af ávinningi þeirra.',
    startReferring: 'Byrja að vísa',
    referralSuccess:
        '🎉 Til hamingju! Þú hefur vísað notendum með góðum árangri og ert að fá bónusstig!',
    unranked: 'Óraðað',
    noPlayersYet: 'Vertu fyrst/ur til að taka þátt!',
    shareVia: 'Deila í gegnum',
    shareOn: 'Deila á {{network}}',
    shareInviteText:
        '🚀 Ég er að vinna mér inn ókeypis dulritun með @CoinomiWallet!\n\nSæktu Coinomi á coinomi.com/downloads og sláðu inn tilvísunarkóðann minn {{referralCode}} til að fá bónus þegar þú gengur í #Coinomi Rewards í appinu.',
    yourStatsThisWeek: 'Tölfræði þín þessa viku',
    pointsMultiplier: 'Stigamargfaldari',
    yourRank: 'Þín staða',
    rewards: 'Verðlaun',
    daily: 'Daglega',
    weekly: 'Vikulega',
    claimRewards: 'Sækja verðlaun',
    copy: 'Afrita',
    // Twitter Challenge
    twitterChallenge: 'Twitter Áskorun',
    connectTwitter: 'Tengja Twitter',
    twitterSuccess: '🎉 Til hamingju! Þú færð nú 10% varanlegan bónus á allar umbunir!',
    twitterPrompt:
        'Tengdu Twitter reikninginn þinn til að fá 10% varanlegan bónus á allar umbunir!',
    pleaseAddUserId: 'Vinsamlegast bættu við userId breytu í vefslóðina',
    emailChallengePrompt:
        'Deildu tölvupóstinum þínum til að fá 10% varanlegan bónus á öll verðlaun!',
    emailChallengeSuccess: '🎉 Tengdur! Þú færð nú 10% varanlegan bónus á öll verðlaun!',
    followKoalaWalletChallenge: 'Fylgdu @coinomiWallet á Twitter til að styðja okkur!',
    twitterAuthSuccessTitle: 'Twitter tengdur með góðum árangri!',
    twitterAuthSuccessMessage:
        'Þú hefur tengt Twitter reikninginn þinn með góðum árangri. Þú getur nú haldið áfram að nota appið.',
    continueToApp: 'Halda áfram í appið',
    twitter_like: 'Líkaði við tíst',
    twitter_retweet: 'Endurtísti tísti',
    disconnect: 'Aftengja',
    followCoinomiWallet: 'Fylgdu @coinomiWallet á Twitter til að styðja okkur!',
    connectedBonus: '🎉 Tengdur! Þú færð nú varanlegan 10% bónus á allar umbunir!',
};
